import { Component, Input } from '@angular/core';
import { ActionItem, AppClientConfiguration, ResponseStatus, ServiceResponse } from '@sdbn/common';
import { AppServerAPI, DialogService } from '@sdbn/common';
import { AsyncSubject, interval, Subscription } from 'rxjs';
import { ActionTabletLprFailureDetailsComponent } from './action-tablet-lpr-failure-details/action-tablet-lpr-failure-details.component';

@Component({
    selector: 'ac-action-tablet-lpr-failures',
    templateUrl: './action-tablet-lpr-failures.component.html',
    styleUrls: ['./action-tablet-lpr-failures.component.scss'],
    standalone: false
})
export class ActionTabletLprFailuresComponent {

  @Input() actionItem: ActionItem;

  resources: Array<string>;
  url: string;

  timerSubscription: Subscription;

  constructor(
    private httpService: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {


    this.loadFailures();

    if (this.actionItem.refreshTimer > 0) {

      this.timerSubscription = interval(this.actionItem.refreshTimer * 1000).subscribe(n => {
        this.loadFailures();
      });
    }

    this.url = this.appClientConfiguration.serverURLRoot + '/app-client/resource/by-id/karlsruhe/';



  }

  private loadFailures(): AsyncSubject<void> {

    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.httpService.execute<Array<any>>('/tmc-common/areaGateLog/findLPRFailuresByGateAndDirection', { gateId: data.areaGateId, direction: data.direction }).subscribe(response => {

      console.log('response is', response);

      let resources = new Array<string>();
      for (let entry of response) {
        resources.push(entry['resourceId']);
      }
      this.resources = resources;

      subject.next();
      subject.complete();

    }, error => {
      subject.error('');
    });
    return subject;
  }

  public handleLPRFailure(resource: string): void {
    this.dialogService.openMaxHeight(ActionTabletLprFailureDetailsComponent, { resourceId: resource }).afterClosed().subscribe(result => {
      if (result) {

        var data = JSON.parse(this.actionItem.data);
        this.httpService.execute<ServiceResponse>('/tmc-common/lpr/handleNumberPlate',
          { numberPlate: result, gateId: data.areaGateId, direction: data.direction }).subscribe(response => {
            if (response.status !== ResponseStatus.FAILED) {
              this.httpService.execute<ServiceResponse>('/tmc-common/areaGateLog/markProcessed',
                { gateId: data.areaGateId, direction: data.direction }).subscribe(response => {
                  this.loadFailures();
                });
            }
          }, error => {
          });
        this.loadFailures().subscribe(() => { });
      }
    });
  }

}
